import { useState } from 'react'

import {
    addErrorToast,
    Button,
    Form,
    Input,
    ModalActionsLegacy as ModalActions,
    ModalBodyLegacy as ModalBody,
    ModalFooterLegacy as ModalFooter,
    ModalHeaderLegacy as ModalHeader,
    ModalLegacy as Modal,
    ModalTitleLegacy as ModalTitle,
    TextArea,
} from '@scouts/ui'

import { PHONE_NUMBER_MAX_LENGTH, PHONE_NUMBER_MIN_LENGTH } from '@/constants'
import { useProfile } from '@/store/profile'
import { useRequestPhoneCall, RequestPhoneCallParams } from '@/store/user'

const ERROR_PHONE_MISSING = 'Por favor, introduce tu número de teléfono'
const MESSAGE_MAX_LENGTH = 2000
const ERROR_MESSAGE_TOO_LONG = `Tu mensaje es demasiado largo - más de ${MESSAGE_MAX_LENGTH} caracteres`

interface PhoneCallRequestModalProps {
    onClose: VoidFunction
    onPhoneRequest?: (data: RequestPhoneCallParams) => void
}

export const PhoneCallRequestModal = ({ onClose, onPhoneRequest }: PhoneCallRequestModalProps) => {
    const profile = useProfile()
    const { requestPhoneCall, isLoading: isLoadingRequestPhoneCall } = useRequestPhoneCall()

    const [phoneNumber, setPhoneNumber] = useState(profile?.phoneNumber || '')
    const [message, setMessage] = useState('')

    const handleSubmit = () => {
        if (!phoneNumber.trim()) {
            addErrorToast({ body: ERROR_PHONE_MISSING })
            return
        }

        if (message.length > MESSAGE_MAX_LENGTH) {
            addErrorToast({ body: ERROR_MESSAGE_TOO_LONG })
            return
        }

        const payload: RequestPhoneCallParams = { callReason: message, phoneNumber }

        requestPhoneCall(payload).then((response) => {
            if ('error' in response) {
                return
            } else {
                if (onPhoneRequest) onPhoneRequest(payload)
                onClose()
            }
        })
    }

    const isLoading = isLoadingRequestPhoneCall

    return (
        <Modal onClose={onClose}>
            <Form onSubmit={handleSubmit}>
                <ModalHeader>
                    <ModalTitle>Más información para la llamada telefónica</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <Form.Row>
                        <Form.Row.Title>Teléfono de contacto</Form.Row.Title>
                        <Form.Row.Content>
                            <Input
                                name="phoneNumber"
                                value={phoneNumber}
                                onChange={({ value }) => setPhoneNumber(value)}
                                minLength={PHONE_NUMBER_MIN_LENGTH}
                                maxLength={PHONE_NUMBER_MAX_LENGTH}
                                required
                                autoFocus={!phoneNumber}
                                title={`El número de teléfono debe tener un mínimo de ${PHONE_NUMBER_MIN_LENGTH} y un máximo de ${PHONE_NUMBER_MAX_LENGTH} dígitos.`}
                            />
                        </Form.Row.Content>
                    </Form.Row>
                    <Form.Row>
                        <Form.Row.Title>¿Alguna duda en concreto sobre la quieras hablar?</Form.Row.Title>
                        <Form.Row.Content>
                            <TextArea
                                name="message"
                                placeholder="Escribe aquí tu mensaje"
                                value={message}
                                onChange={({ value }) => setMessage(value)}
                                rows={6}
                                autoFocus={!!phoneNumber}
                                maxLength={255}
                            />
                        </Form.Row.Content>
                    </Form.Row>
                </ModalBody>
                <ModalFooter>
                    <ModalActions>
                        <Button size="large" variant="tertiary" onClick={onClose} disabled={isLoading}>
                            No lo necesito
                        </Button>
                        <Button type="submit" isLoading={isLoading} size="large">
                            Enviar mi mensaje
                        </Button>
                    </ModalActions>
                </ModalFooter>
            </Form>
        </Modal>
    )
}
